module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerLight-f39bd71f57103e29b3dd4067008a1f8c.woff";